/** Rows in one CSV export; keep in step with packages/api/src/config/screener.ts. */
export const SCREENER_EXPORT_ROW_CAP = 500;
